import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';

export function footfall(section: Section): void {
  trackFootfallEvent(Event.CLICKED, { clickMetadata: { section }, clickType: 'member-sitebar' });
}
